<template>
  <div class="content">
    <alta-de-avl ref="altaDeAvl"></alta-de-avl>
    <modificar-avl @avlUpdated="avlUpdated" ref="modificarAvl"></modificar-avl>
    <TrasladoDeAvls
      @update="update"
      :idAvls="this.idAvls"
      :rowData="this.rowData"
      :seleccionados="this.seleccionados"
      @updateSelection="updateSelection"
    ></TrasladoDeAvls>

    <resumen-de-avls ref="resumenDeAvls"></resumen-de-avls>

    <div class="container-fluid h-100">
      <div class="container-fluid h-100">
        <div class="row h-100">
          <div class="col h-100">
            <card-item
              class="striped-tabled-with-hover"
              body-classes="table-full-width table-responsive"
            >
              <template slot="header">
                <div class="d-flex justify-content-between">
                  <div>
                    <h4 class="card-title">AVL</h4>
                    <p class="card-category">Listado</p>
                  </div>
                  <div class="button-group">
                    <button @click="procesarAvls" class="btn btn-success">
                      Procesar Avl's
                    </button>
                    <button @click="resumenDeAvls" class="btn btn-warning">
                      Historial de AVL's
                    </button>
                    <button @click="altaDeAvl" class="btn btn-primary">
                      Alta de AVL's
                    </button>
                  </div>
                </div>
              </template>

              <div class="container-fluid h-100">
                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <label for="quickFilter" class="label"
                        >Filtro rapido</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="quickFilter"
                        v-model="quickFilter"
                      />
                    </div>
                    <div class="row" v-if="this.seleccionados.length">
                      <div class="col">
                        <div class="form-group">
                          <label>Avls seleccionados</label>
                          <div class="row mb-2 ml-0">
                            <div
                              class=""
                              v-for="item in seleccionados"
                              :key="`${item.id_avl}`"
                            >
                              <span
                                class="badge"
                                style="border: solid gray 1px"
                                type="text"
                              >
                                {{ item.id_avl }}

                                <button
                                  @click="quitarAvls(item)"
                                  style="
                                    position: relative;
                                    color: black;
                                    border-radius: 50%;
                                    border: solid black 1px;
                                  "
                                  class="btn btn-sm"
                                >
                                  X
                                </button>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row" style="height: 100%">
                  <div class="col" style="position: relative; height: 100%">
                    <ag-grid-vue
                      style="width: 100%; height: 60vh"
                      class="ag-theme-alpine"
                      @grid-ready="onGridReady"
                      :gridOptions="gridOptions"
                      :columnDefs="columnDefs"
                      :defaultColDef="defaultColDef"
                      :modules="modules"
                      @selection-changed="onSelectedChanged"
                      rowSelection="multiple"
                      :rowMultiSelectWithClick="true"
                      :getContextMenuItems="getContextMenuItems"
                      :rowData="rowData"
                      :getRowStyle="getRowStyle"
                    >
                    </ag-grid-vue>
                  </div>
                </div>
              </div>
            </card-item>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import { AllModules } from "ag-grid-enterprise";

import AltaDeAvl from "./ABM/AltaDeAvl";
import ModificarAvl from "./ABM/ModificarAvl";
import ResumenDeAvls from "@/pages/Avl/ResumenDeAvls";
import fechaIngresoComponentVue from "./ABM/fechaIngresoComponent.vue";
import TrasladoDeAvls from "./ABM/TrasladoDeAvlsModal.vue";

export default {
  name: "AvlList",
  components: {
    AgGridVue,
    AltaDeAvl,
    ModificarAvl,
    ResumenDeAvls,
    TrasladoDeAvls,
  },
  mounted() {
    document.getElementsByClassName("ag-watermark")[0].style.display = "none";
  },

  computed: {
    rowData: {
      get() {
        return this.$store.getters["avls/getAvls"];
      },
      set(val) {
        this.$store.commit("avls/setAvls", val);
      },
    },
  },

  methods: {
    limpiarFiltro() {
      this.quickFilter = "";
    },
    onSelectedChanged() {
      const selectNodes = this.gridApi.getSelectedNodes();
      this.limpiarFiltro();
      this.seleccionados = selectNodes.map((item) => item.data);
      const selectAvls = selectNodes.map((item) => item.data.id_avl);
      this.idAvls = selectAvls.toString();
    },
    quitarAvls(params) {
      this.seleccionados = this.seleccionados.filter(
        (item) => item.id_avl !== params.id_avl,
      );
    },
    actualizarAvlsSeleccionados() {
      const selectedNodes = this.gridApi.getSelectedNodes();
      selectedNodes.forEach((node) => {
        if (
          !this.seleccionados.find(
            (item) => `${item.id_avl}` === `${node.data.id_avl}`,
          )
        ) {
          this.gridApi.deselectNode(node);
        }
      });
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      this.gridApi.showLoadingOverlay();
      this.$store.dispatch("avls/getAvls").then(() => {
        this.gridApi.hideOverlay();
        setTimeout(() => this.autoSizeAll(false), 50);
      });
    },
    autoSizeAll(skipHeader) {
      let allColumnIds = [];
      this.columnApi.getAllColumns().forEach(function (column) {
        allColumnIds.push(column.colId);
      });
      this.columnApi.autoSizeColumns(allColumnIds, skipHeader);
    },

    procesarAvls() {
      this.$bvModal.show("trasladarAvls");
    },
    altaDeAvl() {
      this.$refs.altaDeAvl.$refs.modal.show();
    },
    resumenDeAvls() {
      this.$router.push("/admin/avl/historial-avls");
    },
    modificarAvl(node) {
      this.modifyAvlNodeId = node.id;
      this.$store.commit("avls/setAvlForModify", {
        ...node.data,
        fecha_ingreso: this.$moment(node.data.fecha_ingreso).format(
          "YYYY-MM-DDTHH:mm:ss",
        ),
      });
      this.$refs.modificarAvl.$refs.modal.show();
    },
    avlUpdated(avlData) {
      let node = this.gridApi.getRowNode(this.modifyAvlNodeId);
      node.setData(avlData);
      this.modifyAvlNodeId = null;
    },
    getContextMenuItems() {
      return ["copy", "excelExport"];
    },
    getRowStyle() {
      return { textAlign: "center" };
    },

    updateSelection(nuevosSeleccionados) {
      this.seleccionados = nuevosSeleccionados;

      this.gridApi.deselectAll();

      this.gridApi.forEachNode((node) => {
        const estaSeleccionado = nuevosSeleccionados.find(
          (item) => item.id_avl.toString() === node.data.id_avl.toString(),
        );

        if (estaSeleccionado) {
          node.setSelected(true);
        }
      });
      const selectAvls = nuevosSeleccionados.map((item) => item.id_avl);
      this.idAvls = selectAvls.toString();
    },
    update() {
      this.gridApi.showLoadingOverlay();
      this.$store.dispatch("avls/getAvls").then(() => {
        this.seleccionados = [];
        this.gridApi.hideOverlay();
      });
    },
  },
  data: () => ({
    modifyAvlNodeId: null,

    seleccionados: [],
    idAvls: "",

    quickFilter: "",

    // ag-grid config
    modules: AllModules,

    gridApi: null,

    gridOptions: {
      statusBar: {
        statusPanels: [
          {
            statusPanel: "agTotalAndFilteredRowCountComponent",
            align: "left",
          },
          {
            statusPanel: "agTotalRowCountComponent",
            align: "center",
          },
          { statusPanel: "agFilteredRowCountComponent" },
          { statusPanel: "agSelectedRowCountComponent" },
          { statusPanel: "agAggregationComponent" },
        ],
      },
      enableClipboard: true,
      enableRangeSelection: true,
      suppressCopyRowsToClipboard: false,
    },
    defaultColDef: {
      sortable: true,
      filter: true,
      resizable: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      cellClass: "ag-center-cols-cell",
      enableCellTextSelection: true,
      ensureDomOrder: true,
    },
    columnDefs: [
      {
        headerName: "#AVL",
        field: "id_avl",
        maxWidth: 120,
        minWidth: 80,
        checkboxSelection: true,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
      },
      {
        headerName: "# CHIP",
        field: "id_chip",
        maxWidth: 120,
        minWidth: 80,
        valueGetter: (params) => {
          return params.data.id_chip ? params.data.id_chip : "-";
        },
      },
      {
        headerName: "Número de teléfono",
        field: "numero",
        maxWidth: 150,
        minWidth: 100,
        valueGetter: (params) => {
          return params.data.id_chip ? params.data.numero : "-";
        },
      },
      {
        headerName: "Empresa de telefonía",
        field: "empresa",
        maxWidth: 150,
        minWidth: 100,
        valueGetter: (params) => {
          return params.data.id_chip ? params.data.empresa : "-";
        },
      },
      {
        headerName: "IMEI",
        field: "imei",
        maxWidth: 180,
        minWidth: 160,
      },
      {
        headerName: "Modelo",
        field: "modelo",
        maxWidth: 110,
        minWidth: 100,
      },
      {
        headerName: "Fecha de Ingreso",
        cellRendererFramework: fechaIngresoComponentVue,
        comparator: (valueA, valueB, nodeA, nodeB) => {
          return (
            new Date(nodeA.data.fecha_ingreso.substring(0, 10)) -
            new Date(nodeB.data.fecha_ingreso.substring(0, 10))
          );
        },
        hide: true,
      },
      {
        headerName: "Firmware",
        field: "Firmware",
        hide: true,
      },
      {
        headerName: "Instalador",
        field: "ApellidoNombre",
        maxWidth: 150,
        minWidth: 130,
      },
      {
        headerName: "Ubicación",
        field: "ubicacion",
        maxWidth: 200,
        minWidth: 160,
        autoHeight: true,
        wrapText: true,
      },
      {
        headerName: "Batería",
        cellRenderer: (params) => {
          if (params.data.bateria) {
            return params.data.bateria;
          }
          return "-";
        },
        hide: true,
      },
      {
        headerName: "Estado",
        field: "estado",
      },
      {
        headerName: "Comentario",
        field: "comentario",
        maxWidth: 300,
        minWidth: 200,
        autoHeight: true,
        wrapText: true,
      },
    ],
  }),
  watch: {
    quickFilter(val) {
      this.gridApi.setQuickFilter(val);
    },
    seleccionados() {
      this.actualizarAvlsSeleccionados();
    },
  },
};
</script>
<style>
.ag-theme-alpine .ag-header-cell-label {
  justify-content: center;
}
</style>
